import {
  documentationUri,
  euCssStylesEnabled as isEUInstance,
  federalCssStylesEnabled as isFederalInstance,
} from '@gonfalon/constants/constants';

// path is after the baseUrl
// path example: 'home/getting-started' NOT 'docs/home/getting-started'
// leading slash is optional '/home/getting-started'
export function getDocumentationUrl(path: string = ''): string {
  let baseUrl = documentationUri() || 'https://launchdarkly.com/docs';
  // Remove trailing slash, if any, to avoid double slashes when appending
  baseUrl = baseUrl.replace(/\/+$/, '');

  const basePathname = new URL(baseUrl).pathname.replace(/\/+$/, '').replace(/^\//, '');
  const normalizedPath = path.replace(/^\//, '');
  const strippedPath =
    basePathname && normalizedPath.startsWith(`${basePathname}/`)
      ? normalizedPath.slice(basePathname.length + 1)
      : normalizedPath;

  if (isFederalInstance()) {
    baseUrl = `${baseUrl}/fed-docs`;
  } else if (isEUInstance()) {
    baseUrl = `${baseUrl}/eu-docs`;
  }

  // Ensure baseUrl ends with / so new URL() properly handles path segments
  baseUrl = `${baseUrl}/`;

  return new URL(strippedPath, baseUrl).toString().replace(/\/$/, '');
}
